import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { PAGE_START } from '~/common/constants/page';
import {
  addDepartment,
  deleteDepartment,
  getClientDepartments,
  getClientDepartmentsInfo,
  renameDepartment,
} from '~/components/Admin/DepartmentsPage/DepartmentsPage.data';
import EcCard from '~/components/Shared/EcCard/EcCard';
import EcDepartmentsTable from '~/components/Shared/EcDepartmentsTable/EcDepartmentsTable';
import EcMembersTable from '~/components/Shared/EcMembersTable/EcMembersTable';
import EcModal from '~/components/Shared/EcModal/EcModal';
import { showToast } from '~/components/Shared/EcToast/showToast';
import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Modal } from '~/eds/src/components/Modal/Modal';
import { Paginate } from '~/eds/src/components/Paginate/Paginate';
import { StatusMessage } from '~/eds/src/components/StatusMessage/StatusMessage';
import { Text } from '~/eds/src/components/Text/Text';
import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { QueryParamType } from '~/enums/QueryParamType';
import { DepartmentNameModal } from '~/features/departments/DepartmentNameModal';
import { OnboardingIdType } from '~/features/onboarding/OnboardingIdType';
import { FlagType } from '~/flags/flags';
import { withFlags } from '~/flags/withFlags';
import { withCurrentUser } from '~/hocs/withCurrentUser';
import { api } from '~/redux/api/createApi';
import { TagType } from '~/redux/api/TagType';
import { RoutePathType } from '~/routing/enums';
import { generateNav } from '~/routing/nav';
import { withRouting } from '~/routing/withRouting';
import { MODAL_DELETE_DEPARTMENT, MODAL_NAME } from '~/types/modal.types';
import { ERROR, SUCCESS } from '~/types/toast.types';
import {
  getPageSearchQueryByKey,
  updatePageSearchQuery,
} from '~/utils/searchQuery';

const tableStyles = { padding: '0 16px' };
const PAGE_SIZE = 20; //BE defines

class Page extends Component {
  constructor(props) {
    super(props);

    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.onDepartmentCreate = this.onDepartmentCreate.bind(this);
    this.onDepartmentRename = this.onDepartmentRename.bind(this);
    this.onDepartmentDelete = this.onDepartmentDelete.bind(this);
    this.handleAddUnassignedUsers = this.handleAddUnassignedUsers.bind(this);

    this.state = {
      selectedDepartment: null,
      selectedItem: null,
      unassignedUsers: [],
      unassignedUsersDisplayed: false,
      departmentsSelected: [],
    };
  }

  componentDidMount() {
    const page = getPageSearchQueryByKey(QueryParamType.Page, PAGE_START);
    this.getClientDepartmentsInfo();
    this.setState({ page }, () => {
      this.getClientDepartments();
      updatePageSearchQuery({
        [QueryParamType.Page]: page,
      });
    });
  }

  getClientDepartmentsInfo() {
    const {
      params: { clientId },
    } = this.props;

    getClientDepartmentsInfo(clientId)
      .then((data) => {
        const { unassignedUsers } = data;
        this.setState({
          loading: false,
          unassignedUsers,
        });
      })
      .catch((error) => {
        const {
          response: { status },
        } = error;
        if (status === 403) {
          this.setState({ noAccess: true });
        } else {
          this.setState({ errorLoading: true });
        }
      });
  }

  getClientDepartments() {
    const {
      params: { clientId },
    } = this.props;
    const { page } = this.state;

    this.setState({ loading: true });

    // to re-fetch the departments we need to invalidate the flag,
    // since this component wasn't connected to redux and doesn't use RTKQ to manage requests,
    // we need to do it manually.
    this.props.dispatch(
      api.util.invalidateTags([{ type: TagType.Department, id: 'LIST' }]),
    );

    getClientDepartments(clientId, page)
      .then((res) => {
        this.setState({
          departments: res,
          loading: false,
          errorLoading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 403) {
          this.setState({
            loadingUsers: false,
            errorLoadingDepartments: false,
          });
        } else {
          this.setState({ loadingUsers: false, errorLoadingDepartments: true });
        }
      });
  }

  handleShowModal(modal, departmentName, forSubdepartment = false) {
    this.setState({
      modal,
      selectedDepartment: departmentName,
      forSubdepartment,
    });
  }

  handleHideModal() {
    this.setState({
      modal: null,
      selectedItem: null,
    });
  }

  handleAddUnassignedUsers(members) {
    this.setState({ members });
  }

  handlePageClick(clickedPage) {
    const selectedPage = clickedPage.selected + 1;
    this.setState({ page: selectedPage }, () => {
      this.getClientDepartments();
      updatePageSearchQuery({ [QueryParamType.Page]: selectedPage }, true);
    });
  }

  renderPagination() {
    const { departments, page } = this.state;
    return (
      departments &&
      departments.count > PAGE_SIZE && (
        <Layout justify="center">
          <Paginate
            totalCount={departments.count}
            pageSize={PAGE_SIZE}
            pageIndex={page}
            onUpdatePageIndex={(selectedPage) => {
              this.setState({ page: selectedPage }, () => {
                this.getClientDepartments();
                updatePageSearchQuery(
                  { [QueryParamType.Page]: selectedPage },
                  true,
                );
              });
            }}
          />
        </Layout>
      )
    );
  }

  renderDepartmentNameModal() {
    const { intl, flags } = this.props;
    const { selectedDepartment, forSubdepartment } = this.state;

    const enableModalConsolidation = flags[FlagType.ModalConsolidation];
    const labelText = intl.formatMessage({
      id: 'Departments.departmentNameLabel',
      defaultMessage: 'DEPARTMENT NAME',
      description: 'Department name form field label',
    });
    let title;
    let itemsCurrentName;
    let itemsParentDepartmentId;

    let confirmButtonText;
    let handleNameChange;

    if (selectedDepartment && !forSubdepartment) {
      title = intl.formatMessage({
        id: 'Departments.renameDepartmentTitle',
        defaultMessage: 'Rename Department',
        description: 'Rename department modal title',
      });
      itemsCurrentName = selectedDepartment.department_name;
      itemsParentDepartmentId = null;
      confirmButtonText = intl.formatMessage({
        id: 'Departments.saveButton',
        defaultMessage: 'Save',
        description: 'Save button text',
      });
      handleNameChange = this.onDepartmentRename;
    } else if (selectedDepartment && !!forSubdepartment) {
      title = intl.formatMessage({
        id: 'Departments.addSubdepartmentTitle',
        defaultMessage: 'Add Subdepartment',
        description: 'Add subdepartment modal title',
      });
      itemsCurrentName = '';
      itemsParentDepartmentId = selectedDepartment.department_id;

      confirmButtonText = intl.formatMessage({
        id: 'Departments.createSubdepartmentButton',
        defaultMessage: 'Create Subdepartment',
        description: 'Create subdepartment button text',
      });
      handleNameChange = this.onDepartmentCreate;
    } else {
      title = intl.formatMessage({
        id: 'Departments.addDepartmentTitle',
        defaultMessage: 'Add Department',
        description: 'Add department modal title',
      });
      itemsCurrentName = '';
      itemsParentDepartmentId = null;

      confirmButtonText = intl.formatMessage({
        id: 'Departments.createDepartmentButton',
        defaultMessage: 'Create Department',
        description: 'Create department button text',
      });
      handleNameChange = this.onDepartmentCreate;
    }

    return enableModalConsolidation ? (
      <DepartmentNameModal
        title={title}
        labelText={labelText}
        initialValue={itemsCurrentName}
        confirmButtonText={confirmButtonText}
        itemsParentFolderId={itemsParentDepartmentId}
        onConfirm={handleNameChange}
        onCancel={this.handleHideModal}
        itemsCurrentName={itemsCurrentName}
      />
    ) : (
      <EcModal
        id={OnboardingIdType.AddDepartmentModal}
        modalType={MODAL_NAME}
        width="560px"
        title={title}
        labelText={labelText}
        itemsCurrentName={itemsCurrentName}
        itemsParentFolderId={itemsParentDepartmentId}
        confirmButtonText={confirmButtonText}
        handleNameChange={handleNameChange}
        hideModal={this.handleHideModal}
      />
    );
  }

  renderDeleteDepartmentModal() {
    const { intl } = this.props;
    const { selectedDepartment } = this.state;

    return (
      <Modal
        title={intl.formatMessage({
          id: 'Departments.deleteDepartmentTitle',
          defaultMessage: 'Delete Department?',
          description: 'Delete department modal title',
        })}
        children={
          <Text>
            {intl.formatMessage(
              {
                id: 'Departments.deleteDepartmentConfirmation',
                defaultMessage:
                  "Are you sure you want to delete {departmentName} department? You won't be able to undo this action.",
                description:
                  'Delete department confirmation message. Example: departmentName = "Engineering"',
              },
              {
                departmentName: selectedDepartment.department_name,
              },
            )}
          </Text>
        }
        onHide={this.handleHideModal}
        isVisible={true}
        primaryAction={{
          text: intl.formatMessage({
            id: 'Departments.deleteButton',
            defaultMessage: 'Delete',
            description: 'Delete button text',
          }),
          variant: 'danger',
          onClick: this.onDepartmentDelete,
        }}
      />
    );
  }

  onDepartmentCreate(name) {
    const { intl } = this.props;
    const {
      params: { clientId },
    } = this.props;

    const { selectedDepartment } = this.state;

    const members = [];
    const parent = selectedDepartment ? selectedDepartment.department_id : null;

    addDepartment(name, members, parent, clientId)
      .then((data) => {
        this.getClientDepartments();
        this.handleHideModal();
        showToast(
          SUCCESS,
          intl.formatMessage(
            {
              id: 'Departments.departmentCreatedSuccess',
              defaultMessage: '{departmentName} department has been created.',
              description:
                'Success message when department is created. Example: departmentName = "Engineering"',
            },
            {
              departmentName: data.department_name,
            },
          ),
        );
      })
      .catch((err) => {
        if (
          err &&
          err.response.status === 400 &&
          err.response &&
          err.response.data
        ) {
          showToast(ERROR, err.response.data[0]);
        } else {
          showToast(
            ERROR,
            intl.formatMessage({
              id: 'Departments.departmentCreateError',
              defaultMessage:
                'An error occurred while creating the new department.',
              description: 'Error message when department creation fails',
            }),
          );
        }
      });
  }

  onDepartmentRename(name) {
    const { intl } = this.props;
    const { selectedDepartment } = this.state;
    const {
      params: { clientId },
    } = this.props;
    const departmentId = selectedDepartment.department_id;

    renameDepartment(clientId, departmentId, name)
      .then((data) => {
        showToast(
          SUCCESS,
          intl.formatMessage(
            {
              id: 'Departments.departmentRenamedSuccess',
              defaultMessage: 'Department is renamed to {departmentName}.',
              description:
                'Success message when department is renamed. Example: departmentName = "Engineering"',
            },
            {
              departmentName: data.department_name,
            },
          ),
        );
        this.getClientDepartments();
        this.handleHideModal();
      })
      .catch((err) => {
        if (
          err &&
          err.response.status === 400 &&
          err.response &&
          err.response.data
        ) {
          showToast(ERROR, err.response.data[0]);
        } else {
          showToast(
            ERROR,
            intl.formatMessage({
              id: 'Departments.departmentRenameError',
              defaultMessage:
                'An error occurred while renaming the new department.',
              description: 'Error message when department rename fails',
            }),
          );
        }
      });
  }

  onDepartmentDelete() {
    const { intl } = this.props;
    const { selectedDepartment } = this.state;
    const departmentId = selectedDepartment.department_id;

    deleteDepartment(departmentId)
      .then(() => {
        showToast(
          SUCCESS,
          intl.formatMessage({
            id: 'Departments.departmentDeletedSuccess',
            defaultMessage: 'Department is deleted.',
            description: 'Success message when department is deleted',
          }),
        );
        this.getClientDepartments();
        this.setState({ modal: null });
      })
      .catch(() => {
        showToast(
          ERROR,
          intl.formatMessage({
            id: 'Departments.departmentDeleteError',
            defaultMessage: 'An error occurred while deleting the department.',
            description: 'Error message when department deletion fails',
          }),
        );
        this.setState({ modal: null });
      });
  }

  renderUnassignedUsers() {
    const { intl } = this.props;
    const { unassignedUsers, unassignedUsersDisplayed } = this.state;

    if (!unassignedUsers.length) {
      return null;
    } else if (!unassignedUsersDisplayed) {
      return (
        <StatusMessage
          message={intl.formatMessage(
            {
              id: 'Departments.unassignedUsersMessage',
              defaultMessage:
                'There are {count} {count, plural, one {User} other {Users}} not assigned to any departments.',
              description:
                'Message showing count of unassigned users with pluralization. Example: count = 5',
            },
            {
              count: unassignedUsers.length,
            },
          )}
          status="default"
          action={{
            text: intl.formatMessage(
              {
                id: 'Departments.showUsersAction',
                defaultMessage:
                  'Show {count, plural, one {User} other {Users}}',
                description:
                  'Action text to show unassigned users with pluralization. Example: count = "5"',
              },
              {
                count: unassignedUsers.length,
              },
            ),
            level: 'action',
            onClick: () => this.setState({ unassignedUsersDisplayed: true }),
          }}
        />
      );
    }
    return (
      <EcCard contentStyles={tableStyles}>
        <EcMembersTable
          header={intl.formatMessage({
            id: 'Departments.unassignedUsersHeader',
            defaultMessage: 'Unassigned Users',
            description: 'Header for unassigned users table',
          })}
          listItems={unassignedUsers}
          handleShowModal={this.handleShowModal}
          handleAddUnassignedUsers={this.handleAddUnassignedUsers}
        />
      </EcCard>
    );
  }

  renderDepartmentsTableData() {
    const {
      params: { clientId },
    } = this.props;
    const { departments, loading } = this.state;

    if (loading) {
      return (
        <ContentContainer
          loadingContent={{
            isLoading: true,
          }}
        />
      );
    } else if (departments && departments.results.length) {
      return (
        <Layout mt={6}>
          <EcCard contentStyles={tableStyles}>
            <EcDepartmentsTable
              clientId={clientId}
              listItems={departments.results}
              handleShowModal={this.handleShowModal}
            />
          </EcCard>
        </Layout>
      );
    } else {
      return null;
    }
  }

  render() {
    const { intl } = this.props;
    const { modal, errorLoading, noAccess } = this.state;

    const nav = generateNav({
      current: {
        text: intl.formatMessage({
          id: 'Departments.navTitle',
          defaultMessage: 'Departments',
          description: 'Navigation title for departments page',
        }),
        pathname: RoutePathType.AdminConsoleClientDepartments,
      },
      from: RoutePathType.AdminConsoleClient,
      params: {
        clientId: this.props.currentUser.client,
      },
      intl,
    });
    const actions = [
      {
        id: OnboardingIdType.AddDepartmentButton,
        level: 'primary',
        text: intl.formatMessage({
          id: 'Departments.addDepartmentAction',
          defaultMessage: 'Add Department',
          description: 'Add department action button text',
        }),
        onClick: () => this.handleShowModal(MODAL_NAME),
      },
    ];

    const noAccessPlaceholder = noAccess
      ? {
          message: intl.formatMessage({
            id: 'Departments.noAccessMessage',
            defaultMessage:
              'You do not have permission to access this page. To request permission, contact your organization administrator.',
            description: 'No access permission message',
          }),
        }
      : undefined;

    const errorPlaceholder = errorLoading
      ? {
          message: intl.formatMessage({
            id: 'Departments.errorLoadingMessage',
            defaultMessage: 'An error occurred while loading this page.',
            description: 'Error loading page message',
          }),
        }
      : undefined;

    return (
      <PageLayout
        title={intl.formatMessage({
          id: 'Departments.pageTitle',
          defaultMessage: 'Departments',
          description: 'Departments page title',
        })}
        nav={nav}
        actions={actions}
        placeholderContent={errorPlaceholder || noAccessPlaceholder}
      >
        <Layout direction="column">
          {this.renderUnassignedUsers()}
          {this.renderDepartmentsTableData()}
          {this.renderPagination()}
          {modal === MODAL_NAME ? this.renderDepartmentNameModal() : null}
          {modal === MODAL_DELETE_DEPARTMENT
            ? this.renderDeleteDepartmentModal()
            : null}
        </Layout>
      </PageLayout>
    );
  }
}

Page = connect()(Page);

export default withCurrentUser(withRouting(withFlags(injectIntl(Page))));
